/* ==========================================
   PURE CRAFT — CART UPSELL BUTTONS
========================================== */

(function () {

  if (window.pcCartUpsellsInitialized) return;

  window.pcCartUpsellsInitialized = true;

  document.addEventListener('click', async function (event) {

    const button = event.target.closest(
      '.pc-cart-upsells__add'
    );

    if (!button || button.disabled) return;

    event.preventDefault();

    const variantId = Number(
      button.dataset.variantId
    );

    if (!variantId) return;

    const cartDrawer = document.querySelector(
      'cart-drawer'
    );

    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'ADDING...';

    try {

      const response = await fetch(
        window.Shopify.routes.root + 'cart/add.js',
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json'
          },

          body: JSON.stringify({

            items: [
              {
                id: variantId,
                quantity: 1,

                properties: {
                  _pc_cart_upsell: 'yes'
                }
              }
            ],

            sections: [
              'cart-drawer',
              'cart-icon-bubble'
            ],

            sections_url: window.location.pathname

          })

        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          'Unable to add product.'
        );
      }

      if (
        cartDrawer &&
        result.sections &&
        result.sections['cart-drawer']
      ) {

        cartDrawer.renderContents(result);

      } else {

        window.location.reload();

      }

    } catch (error) {

      console.error(
        'Pure Craft upsell error:',
        error
      );

      button.disabled = false;
      button.textContent = originalText;

      alert(
        error.message ||
        'Unable to add product.'
      );

    }

  });

})();